// Only the employee DTO supplies contact data; account lookup entries are names/avatars.
function employeeContactCard(details) {
    if (!details) return null;
    const access = details.permissions && details.permissions.card_access || {};
    const contacts = access.view && access.view.contacts && Array.isArray(details.contact_methods) ? details.contact_methods : [];
    const value = type => (contacts.find(contact => contact.contact_type === type) || {}).value || null;
    const telegram = access.view && access.view.contacts && details.telegram_contact || {};
    const telegramMethod = contacts.find(contact => contact.contact_type === 'telegram') || {};
    const username = telegram.username || String(telegramMethod.normalized_value || telegramMethod.value || '')
        .trim().replace(/^(?:https?:\/\/)?(?:t\.me|telegram\.me)\//i, '').replace(/^@/, '') || null;
    return {
        employee_id: details.employee_id,
        user_id: details.user_id,
        full_name: details.full_name,
        first_name: details.first_name,
        last_name: details.last_name,
        avatar_url: details.avatar_url,
        active: details.lifecycle_status === 'active',
        position: details.operational_position,
        departments: details.operational_department ? [details.operational_department] : [],
        phone: value('phone'),
        gmail: value('email'),
        telegram_username: username,
        telegram_url: telegram.url || (username ? `https://telegram.me/${encodeURIComponent(username)}` : null),
        can_open_card: access.can_open === true
    };
}

module.exports = {employeeContactCard};
